import './c-tabs-content.scss';
import template from './tabs-content.vhtml';

export default {
	template,
	props: {
		selected: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			tabs: [],
		};
	},
	mounted() {
		this.tabs = this.$children;
		this.selectTab();
	},
	watch: {
		selected: function () {
			this.selectTab();
		},
	},
	methods: {
		selectTab() {
			this.tabs.forEach( ( tab, index ) => {
				tab.$data.isSelected = ( this.selected === index );
			});
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/tabs-content/tabs-content.js